export default __webpack_public_path__ + "static/media/image.price-ur-plastic.2a2f167c.png";